import React, { useEffect } from 'react';

import Description from '../Description/Description';
import RegisterForm from '../RegisterForm/RegisterForm';
import "./App.scss";
import { GA_Push } from '../../Services/analytics';

const App = () => {
    useEffect(() => {
        GA_Push("Form Displayed");
    }, []);

    return (
           <div className="app-container" >
                <Description />
                <RegisterForm />
                {/* <div className="man-sitting"></div> */}
            </div>
        // <div className="app-container-new">
        //     <div className='headers-txt'>

        //     <h2>רוצים להמשיך לקרוא?</h2><br></br>
        //     <h3>
        //     כל הכתבות והתכנים הכי מעניינים <br></br>מחכים לכם ב
        //         <span className='ynet-p'></span>
        //     </h3>
        //     <h4>₪חודש ראשון ב-5.90</h4>

        //     </div>
            
        //     <div className='bottom-area'></div>
        //     <div className="phone-articles"></div>

        // </div>
    )
}

export default App
